import { useQuery } from '@tanstack/react-query';
import { getOffer } from '../api/booking';
import type { ConsumerOffer } from '../types/dtos';
import { ApiError } from '../api/client';

export function useOffer(token: string) {
  return useQuery<ConsumerOffer, ApiError>({
    queryKey: ['offer', token],
    queryFn: () => getOffer(token),
    retry: (failureCount, err) => {
      if (err instanceof ApiError && err.status >= 400 && err.status < 500) return false;
      return failureCount < 2;
    },
    staleTime: 30_000,
  });
}
